import { Accordion, Box, Group, Flex, Text, Button } from "@mantine/core";
import { WarningItem } from "@components/data/dataset-warnings-data";

type CwiggoWarningsAccordionProps = {
  data: WarningItem[];
};

export const CustomWarningsAccordion: React.FC<CwiggoWarningsAccordionProps> = ({
  data,
}) => (
  <Accordion mb="md">
    {data.map((warning) => (
      <Accordion.Item value={warning.id} key={warning.id} mb="xs">
        <Accordion.Control>
          <Group>
            <Box>
              <Text fz="sm" variant="grey-400">
                {warning.time}
              </Text>
            </Box>
            <Text fz="sm" variant="grey-200" fw={700}>
              {warning.title}
            </Text>
          </Group>
        </Accordion.Control>

        {warning.fields.map((field) => (
          <Accordion.Panel key={field.label}>
            <Flex align="center" justify="space-between" w="100%">
              <Text fz="sm" variant="grey-200" fw={700}>
                {field.label}
              </Text>
              <Text fz="sm" variant="grey-200">
                {field.value}
              </Text>
            </Flex>
          </Accordion.Panel>
        ))}

        {warning.buttonLabel && (
          <Accordion.Panel>
            <Flex w="100%" justify="flex-end" mt="sm" py="xs">
              <Button
                variant="ghost"
                size="sm"
                rightSection={
                  <></>
                }
              >
                {warning.buttonLabel}
              </Button>
            </Flex>
          </Accordion.Panel>
        )}
      </Accordion.Item>
    ))}
  </Accordion>
);
